import Schema from "nexia_mobile/models/schema";
import { getLanguageSet } from "nx-components/Locales";

export default class DateRangeFilterSchema extends Schema {
  onParse(rawAttrs) {
    let attrs = super.onParse(rawAttrs);
    // Add date range validation to the start_date and end_date fields
    if (this.validations.end_date) {
      this.validations.end_date.fn = this._getDateErrorMessage;
    }
    if (this.validations.start_date) {
      this.validations.start_date.fn = this._getDateErrorMessage;
    }
    return attrs;
  }

  _getDateErrorMessage(value, attr) {
    const isBefore = attr === "end_date";
    const localeSet = getLanguageSet();
    const language = localeSet.nexia_mobile.pages.EventsPage;

    let endDate = isBefore ? value : this.get("end_date");
    let startDate = isBefore ? this.get("start_date") : value;
    endDate = Date.parse(endDate);
    startDate = Date.parse(startDate);
    if (!isBefore && startDate > Date.now()) {
      // When validating the after date, it should not be later than today
      return language.dateToLate;
    }
    if (isNaN(endDate) || isNaN(startDate)) {
      return null; // A value is unset: no error
    }
    if (endDate < startDate) {
      // When both dates are defined, endDate cannot be before startDate
      return isBefore ? language.dateToEarly : language.dateToLate;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/models/date_range_filter_schema.js